<template>
  <section class="section">
    <div class="container">
      <div class="article mb-18">
        <h3>Технологии</h3>
      </div>
      <div class="row">
        <div class="col-s-3" v-for="(item, index) in stackItems" :key="index">
          <div class="slider-static">
            <div class="slider-static__title">{{ item.title }}</div>
            <div class="slider-static__value">
              <div class="slider-static__bar" :style="{'transform': `scaleX(${item.value})` }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
const name = 'Stack'

function data() {
  return {
    stackItems: [{
      title: 'Vue.js / Vuex / VueRouter',
      value: .98
    }, {
      title: 'PHP, Laravel',
      value: .98
    }, {
      title: 'OctoberCMS',
      value: .98
    }, {
      title: 'HTML5/CSS3',
      value: .98
    }, {
      title: 'JavaScript',
      value: .98
    },{
      title: 'NodeJS',
      value: .84
    }, {
      title: 'ElectronJS',
      value: .84
    }, {
      title: 'Unity',
      value: .68
    }, {
      title: 'Swift',
      value: .72
    }, {
      title: 'Kotlin / Java',
      value: .76
    }, {
      title: 'Адаптивный дизайн',
      value: .93
    }, {
      title: 'Docker, Nginx, Git',
      value: .95
    }, {
      title: 'RESTful API',
      value: .95
    }, {
      title: 'RabbitMQ',
      value: .92
    }, {
      title: '3rd-party интеграции',
      value: .94
    }]
  }
}

export default {
  name,
  data
}

</script>
